import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MonitorlistComponent } from './monitorlist.component';


const routes: Routes = [{ path: '', component: MonitorlistComponent },];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonitorListRoutingModule { }
